module.exports = __webpack_public_path__ + "img/eks.695e4369.png";